/**
 * ottConfig 获取ott page的配置信息
 */
import { BaseModel, apolloQuery, QueryResult } from 'vue-apollo-model';
import gql from 'graphql-tag';
import { Query } from '@/generated-models';

export default class OttConfigModel extends BaseModel {
     @apolloQuery<OttConfigModel>({
         query: gql`
             query visionOttConfig($key: String) {
                 kconf(key: $key)
         }`,
         variables() {
             return {
                 key: 'frontendExplore.vision.ottConfig',
             };
         },
     })
     config!: QueryResult<{ kconf: Query['kconf'] }>;

     get ottConfig() {
         return this.config.data.kconf || {};
     }
}
